<div  *ngIf="getMessages().length > 0 &&  getMessages()[0].detail && getMessages()[0].detail.length > 0"><p-messages *ngIf="!hideBlurb" [styleClass]="'cats-blurp'" [value]="getMessages()" [escape]="false"></p-messages>
</div>